















  import {
    Vue,
    Component
} from "@/shared/vuepack";
import { useWexDebitCardsStore } from "@/shared/store/wexDebitCards";
  @Component({
    components: {
    }
  })
export default class WexDebitCardUpdatePinForm extends Vue {
  wexDebitCardsStore = useWexDebitCardsStore();

}
